import { render, staticRenderFns } from "./ContractListValuesPanel.vue?vue&type=template&id=c536dd4a&"
import script from "./ContractListValuesPanel.vue?vue&type=script&lang=js&"
export * from "./ContractListValuesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports